import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	searchSuggestionsDropdownLabel: {
		id: 'dynamic-cards-search-page.dropdown.search-suggestions-label',
		defaultMessage: 'Search Suggestions Dropdown',
		description: 'Accessibility label for the search suggestions dropdown',
	},
});
